"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getChackraTheme = function getChackraTheme(key) {
  return "var(--chakra-colors-theme-".concat(key, ")");
};

exports.default = getChackraTheme;